import es from './es.json';

export default {
  es: {
    add_product: es
  }
};
